import React from 'react'
import cn from 'classnames'
import FontAwesome from 'react-fontawesome'

const NoteBase = ({ selected, onCheckClick, onNoteClick, children }) => {
  const handleCheckClick = e => {
    e.stopPropagation()
    onCheckClick()
  }
  return (
    <div className={cn('note-base', { selected })} onClick={onNoteClick}>
      <div className="mask">
        {/* <div
          style={{ color: 'white' }}
          className={cn('check', { selected })}
          onClick={handleCheckClick}
        >
          {selected && <FontAwesome name="check" />}
        </div> */}
      </div>
      {children}
      <style jsx>{`
        .note-base {
          padding: 16px;
          position: relative;
          cursor: pointer;
        }
        .note-base.selected {
          background-color: rgba(133, 207, 252, 0.4);
          border-radius: 8px;
        }
        .mask {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
        }
        .mask:hover {
          background-color: rgba(0, 0, 0, 0.04);
        }
        .mask:not(:hover) .check:not(.selected) {
          display: none;
        }
        .check {
          display: flex;
          width: 20px;
          height: 20px;
          position: absolute;
          border-radius: 50%;
          justify-content: center;
          align-items: center;
          top: 25px;
          left: 25px;
          cursor: pointer;
          box-sizing: border-box;
          background-color: #f4f4f7;
          box-shadow: inset 0 1px 2px 0 rgba(0, 0, 0, 0.16);
          border: solid 0.5px rgba(74, 144, 226, 0.72);
        }
        .check.selected {
          background-color: #4990e2;
          border: solid 0.5px #4990e2;
          box-shadow: none;
        }
        .note-base :global(.title) {
          font-size: 18px;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.8);
          margin: 8px 0 4px;
        }
        .note-base :global(.time) {
          color: rgba(0, 0, 0, 0.32);
          line-height: 1.33;
          font-size: 12px;
          margin-bottom: 4px;
        }
        .note-base :global(.type) {
          line-height: 1.07;
          color: rgba(0, 0, 0, 0.4);
          font-size: 15px;
        }
      `}</style>
    </div>
  )
}

export const Text = ({ content, title, time, type, ...props }) => {
  return (
    <NoteBase {...props}>
      <div className="content">
        {content}
      </div>
      <h3 className="title">
        {title}
      </h3>
      <div className="time">
        {time}
      </div>
      <div className="type">
        {type}
      </div>
      <style jsx>{`
        .content {
          border-radius: 8px;
          background-color: #eaf7ff;
          padding: 10px;
          color: #8f8f8f;
        }
      `}</style>
    </NoteBase>
  )
}

export const Article = ({ imgSrc, title, time, type, ...props }) => {
  return (
    <NoteBase {...props}>
      <div>
        <img src={imgSrc} alt="article image" width="100%" />
      </div>
      <h3 className="title">
        {title}
      </h3>
      <div className="time">
        {time}
      </div>
      <div className="type">
        {type}
      </div>
      <style jsx>{`
        img {
          border-radius: 8px;
        }
      `}</style>
    </NoteBase>
  )
}



// WEBPACK FOOTER //
// ./src/components/note/index.js